import type { GridApi } from 'ag-grid-enterprise';
import { GridPaginationState } from '../types/grid';

export type PaginationApi = Pick<
  GridApi,
  | 'paginationGetCurrentPage'
  | 'paginationGetTotalPages'
  | 'paginationGetPageSize'
  | 'paginationGetRowCount'
  | 'paginationIsLastPageFound'
>;

export function toGridPaginationState(api: PaginationApi): GridPaginationState {
  const page = api.paginationGetCurrentPage();
  const pageSize = api.paginationGetPageSize();
  const totalKnown = api.paginationIsLastPageFound();
  const rowCount = totalKnown ? api.paginationGetRowCount() : -1;
  const pageCount = totalKnown ? api.paginationGetTotalPages() : -1;
  if (totalKnown && rowCount === 0) {
    return { page, pageCount, pageSize, rowCount, from: 0, to: 0 };
  }
  const from = page * pageSize + 1;
  const to = totalKnown ? Math.min(rowCount, from + pageSize - 1) : from + pageSize - 1;
  return { page, pageCount, pageSize, rowCount, from, to };
}
